const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCheckIdBioSenseDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 1667 417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h400v100H0z",
    style: {
      fill: "none"
    },
    transform: "scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.252c-4.305-3.826-9.968-6.156-16.166-6.156-6.213 0-11.888 2.34-16.196 6.181l8.382 8.383a12.48 12.48 0 0 1 7.814-2.742c2.938 0 5.643 1.019 7.783 2.717z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(499.26 141.832)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.839C-8.076-3.739-18.932-8.389-30.854-8.389c-11.937 0-22.798 4.667-30.877 12.261l8.355 8.356c5.934-5.456 13.844-8.794 22.522-8.794 8.663 0 16.561 3.326 22.492 8.767z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(560.461 55.25)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-20.67c-5.939 5.487-13.871 8.848-22.575 8.848-8.678 0-16.588-3.339-22.522-8.795l-8.355 8.355C-45.373-4.667-34.513 0-22.575 0-10.611 0 .278-4.682 8.363-12.307z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(525.964 396.37)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.61a12.48 12.48 0 0 1-7.874 2.788 12.48 12.48 0 0 1-7.814-2.741l-8.382 8.382A24.26 24.26 0 0 0-7.874 0c6.24 0 11.937-2.359 16.253-6.231z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(464.71 309.866)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.469-4.469a4.47 4.47 0 1 0 0 8.938 4.47 4.47 0 0 0 0-8.938",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(0 -4.16667 -4.16667 0 431.84 189.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-8.703 3.338-16.624 8.799-22.561L.483-30.877c-7.295 7.76-11.876 18.089-12.227 29.47v2.814c.351 11.381 4.932 21.71 12.227 29.47l8.316-8.316C3.338 16.624 0 8.703 0 0",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(292.94 208.333)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.432a12.5 12.5 0 0 1-.409-1.768l-.016-.099c-.021-.148-.049-.293-.065-.442h-.004v-.108a12.7 12.7 0 0 1 0-2.597v-.109h.004c.016-.149.044-.294.065-.441l.016-.101Q-.267.859 0-.003l.002-.004a12.5 12.5 0 0 1 2.161-4.091l-8.382-8.382a24.27 24.27 0 0 0-6.137 14.789v2.814a24.26 24.26 0 0 0 6.137 14.789l8.382-8.381a12.5 12.5 0 0 1-2.161-4.09z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(382.035 192.85)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.05a4.64 4.64 0 0 1 1.285-3.701c.855-.736 2.52-1.111 4.996-1.111H20.62a4.02 4.02 0 0 1 2.738.707c.563.656.83 1.514.743 2.373v2.271c0 .61-.321.919-.972.919H.001zm28.84 6.265a3.75 3.75 0 0 0 2.455-.677c.605-.644.897-1.52.8-2.399V-9.99a16.2 16.2 0 0 0-.453-4.134 5.75 5.75 0 0 0-1.576-2.759 6.5 6.5 0 0 0-3.026-1.509 21 21 0 0 0-4.824-.46H5.482a28.4 28.4 0 0 0-6.477.622 9.9 9.9 0 0 0-4.169 1.943 7.3 7.3 0 0 0-2.258 3.402 16 16 0 0 0-.688 4.997v7.779a16 16 0 0 0 .688 4.992 7.26 7.26 0 0 0 2.258 3.401 9.7 9.7 0 0 0 4.169 1.92c2.131.438 4.303.639 6.477.6h26.614V4.326H6.282q-3.717 0-4.995-1.135A4.65 4.65 0 0 1 .001-.48v-1.298z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(725.68 225.1)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 29.32h-23.118a9.78 9.78 0 0 1-6.911-2.647 8.68 8.68 0 0 1-2.847-6.633V9.28c-.06-2.52.98-4.94 2.847-6.633A9.77 9.77 0 0 1-23.118 0H0v6.845h-23.118q-2.788 0-2.787 2.443V20.03q0 2.444 2.787 2.444H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(1010.77 147.25)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.292 64.826h7.645V35.172h-7.645zm21.979-14.799 15.354-14.855h-10.447l-13.713 11.195v6.552l14.854 11.909h10.455z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.205 35.174h7.773v29.653h-7.773z",
    style: {
      fill: "#fff"
    },
    transform: "translate(0 -.004)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.939a8.47 8.47 0 0 1-3.174 6.735 11.58 11.58 0 0 1-7.75 2.69h-25.965V1.59h7.849v11.824h18.173q3.016 0 3.017-2.484V.015q0-2.483-3.015-2.483h-26.03v-6.957h25.972a11.58 11.58 0 0 1 7.75 2.689A8.48 8.48 0 0 1-.001.003z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(1422.656 185.545)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-29.659V-.004h-7.774v-11.472h-19.844V0h-7.774v-29.659h7.774v11.479h19.844v-11.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(672.546 270.123)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.991 430.623h16.944q7.087 0 10.437 2.77 3.415 2.835 3.415 8.569 0 7.344-5.734 9.471v.128q7.216 2.192 7.216 10.824 0 6.185-3.479 9.149-3.415 2.963-10.695 2.963h-18.233zm16.493 18.748q4.51 0 6.572-1.546 1.997-1.547 1.997-5.154 0-3.673-1.997-5.219-2.062-1.546-6.572-1.546h-10.695v13.529zm.773 19.843q4.897 0 7.023-1.739t2.126-5.541q0-3.93-2.255-5.605t-7.538-1.675h-10.888v14.431zM632.866 430.687h5.798v43.81h-5.798zM691.429 475.27q-17.009 0-17.009-17.459v-10.437q0-17.46 17.009-17.46t17.009 17.46v10.437q0 17.459-17.009 17.459m0-5.283q5.798 0 8.504-2.963t2.706-9.278v-10.437q0-6.249-2.706-9.277-2.706-2.964-8.504-2.964t-8.504 2.964q-2.706 3.028-2.706 9.277v10.437q0 6.315 2.706 9.278t8.504 2.963M756.499 475.657q-15.784 0-15.784-13.208h5.798q0 7.925 10.051 7.925 9.6 0 9.599-7.023 0-3.543-2.448-5.411-2.383-1.805-8.44-2.706-7.473-1.03-10.63-3.866-3.157-2.77-3.157-8.504 0-6.25 3.866-9.535t11.339-3.286q14.56 0 14.56 12.821h-5.798q0-7.538-8.956-7.538-4.445 0-6.829 1.74t-2.383 5.089q0 3.286 2.319 5.025c1.503 1.117 7.86 2.384 7.86 2.384s6.915 1.332 9.02 2.448q3.027 1.611 4.316 4.188t1.289 6.249q0 12.822-15.398 12.821zM806.237 430.687h28.669v5.283h-22.871v13.465h19.65v5.283h-19.65v14.496h23.515v5.283h-29.313zM869.568 430.687h6.893l20.166 33.309v-33.309h5.605v43.81h-5.67l-21.389-35.305v35.305h-5.605zM951.84 475.657q-15.785 0-15.785-13.208h5.799q0 7.925 10.05 7.925 9.6 0 9.6-7.023 0-3.543-2.448-5.411-2.385-1.805-8.44-2.706-7.474-1.03-10.631-3.866-3.157-2.77-3.157-8.504 0-6.25 3.866-9.535t11.339-3.286q14.56 0 14.56 12.821h-5.798q0-7.538-8.955-7.538-4.446 0-6.829 1.74-2.385 1.739-2.384 5.089 0 3.286 2.319 5.025 2.255 1.676 7.86 2.384 5.863.774 9.02 2.448 3.028 1.611 4.316 4.188 1.289 2.577 1.289 6.249 0 12.822-15.398 12.821zM1001.577 430.687h28.67v5.283h-22.872v13.465h19.65v5.283h-19.65v14.496h23.516v5.283h-29.314z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.05118 0 0 1.16412 77.726 -177.22)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIdBioSenseDark);
export default __webpack_public_path__ + "static/media/CheckIDBioSense_dark.fc53d372da9ad4275951d335f1b95267.svg";
export { ForwardRef as ReactComponent };